import mod from "-!./newEdition.js?vue&type=script&lang=js&"; export default mod; export * from "-!./newEdition.js?vue&type=script&lang=js&"